import React from 'react';
import type { FC, ReactNode } from 'react';
import { match } from 'variant';
import { Box, useAsync } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';
import { hasLegacyAuthData } from '../auth-data.js';

interface Props {
  children: ReactNode;
}

export const WarnLegacyAuthData: FC<Props> = ({ children }) => {
  const { status } = useAsync(hasLegacyAuthData, [], { onError: () => {} });

  return match(status, {
    Error: () => null,
    Loading: () => null,
    Success: ({ result }) => (
      <>
        {result && (
          <Box marginBottom={1}>
            <Trans i18nKey="login.legacy_auth_notice" />
          </Box>
        )}
        {children}
      </>
    ),
  });
};
